module.exports = __webpack_public_path__ + "media/images/web/favicon/favicon-32x32-e0e031e373c34d12628851d23ccd93d4.png";